var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataPlatform-layout"},[_c('MenuBar'),_c('div',{staticClass:"main-container"},[_c('Navbar'),_c('div',{staticClass:"dataPlatform-main"},[_c('div',{staticClass:"dataPlatform-content"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }